export enum EmployeeStatus {
  IN_SETUP = 'IN_SETUP',
  IN_PROBATION = 'IN_PROBATION',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  LONG_LEAVE = 'LONG_LEAVE',
  MATERNITY = 'MATERNITY',
}
